import { render } from "./UpperBanner.vue?vue&type=template&id=7a49b8e4"
const script = {}

import "./UpperBanner.vue?vue&type=style&index=0&id=7a49b8e4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__